import { Component, Input } from '@angular/core';

@Component({
	selector: 'nbr-display',
	template: require('./nbr-display.component.html')
})

export class NumberDisplayComponent {

	private _value: any;

	@Input('value') set value(value: any) { this._value = value; }

	get value(): any {
		if (NumberDisplayComponent.isNumber(this._value)) {
			return this.negate ? -1 * this._value : this._value;
		}

		return "";

	}

	get absoluteValue() { return Math.abs(this.value); }

	@Input() kind: "" | "decimal" | "decimal-0" | "integer" | "percentage" | "percentage-4" = "decimal";

	@Input() negate: boolean = false;

	private static isNumber(val) { return typeof val === 'number'; }
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/components/nbr-display.component.ts